import { getIventisEnvironmentData } from "@iventis/api/src/api";

export const getWhat3WordsApiKey = () => {
    const { appUrl } = getIventisEnvironmentData();
    switch (appUrl) {
        case "localhost:8000":
            return LOCAL_API_KEY;
        case "dev.iventis.studio":
        case "dev-zeus.iventis.studio":
        case "dev-anubis.iventis.studio":
        case "ci.iventis.studio":
        case "dev.iventis.sa.com":
            return DEV_API_KEY;
        case "staging.iventis.studio":
            return STAGING_API_KEY;
        case "app.iventis.com":
        case "app.iventis.sa.com":
            return PROD_API_KEY;
        default:
            throw new Error(`Unknown app URL: ${appUrl}`);
    }
};

const LOCAL_API_KEY = "M56VJZ0M";
const DEV_API_KEY = "IFG567YN";
const STAGING_API_KEY = "STCQMNJF";
const PROD_API_KEY = "A19OCIU0";
